import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import MainApp from './components/MainApp';
import './App.css';

function App() {
  // TODO: Replace with actual authentication logic later
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const checkAuth = async () => {
      const sessionToken = localStorage.getItem('sessionToken');
      
      if (!sessionToken) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      // Set authenticated immediately if token exists
      setIsAuthenticated(true);
      setLoading(false);

      // Validate session with backend in background
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/auth/validate-session`, {
          method: 'GET',
          credentials: 'include', // Include cookies
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          // Session is invalid, clear it and logout
          localStorage.removeItem('sessionToken');
          localStorage.removeItem('userEmail');
          setIsAuthenticated(false);
        }
      } catch (error) {
        // Network error - keep user logged in, validation will retry on next API call
        console.warn('Session validation failed, but keeping user logged in');
      }
    };

    checkAuth();

    // Listen for storage changes (login/logout events)
    const handleStorageChange = (e) => {
      if (e.key === 'sessionToken') {
        checkAuth();
      }
    };

    // Custom event for same-window storage changes
    const handleAuthChange = () => {
      checkAuth();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('authChange', handleAuthChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authChange', handleAuthChange);
    };
  }, []);

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    if (loading) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
    }
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainApp />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
